module.exports = __webpack_public_path__ + "static/img/img-good.814b1163.png";